import { getSiteInfo } from './SiteConfigs.js';

let SITE_INFO = getSiteInfo();

let LAZY_ADS_ENABLED = false;
if (typeof SITE_INFO['lazy_ads'] !== 'undefined' && SITE_INFO['lazy_ads'] == true) {
    LAZY_ADS_ENABLED = true;
}

let PREBIDDING_ENABLED = false;
if (typeof SITE_INFO['prebid_src'] !== 'undefined' && SITE_INFO['prebid_src'] != '') {
    PREBIDDING_ENABLED = true;
}

window.HAS_INIT_ADS = false;

function getAdsId(){
    // window.AD_ID = '1004503';
    return '1004503';
}

function getAdsInfo(){

    let AD_ID = getAdsId();

    return {
        'div-gpt-ad-1390595004947-7' : {
            'sizes' : [
                [728, 90], [970, 90], [970, 250]
            ],
            'name' : '/'+AD_ID+'/RC_728_by_90_top',
            'class' : 'RC-AD-TOP-BANNER',
            'loaded' : false,
            'closeable_pages' : ['home', 'article', 'polls', 'video', 'maps'],
            //'ic_override' : '//ads.investingchannel.com/adtags/realclearmarkets/economics/728x90.js',
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1390595004947-6' : {
            'sizes' : [
                [728, 90]
            ],
            'name' : '/'+AD_ID+'/RC_728_by_90_bottom',
            'class' : 'RC-AD-BOTTOM-BANNER',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1416850836025-4' : {
            'sizes' : [
                [300, 600]
            ],
            'name' : '/'+AD_ID+'/RC_300_by_600_bottom',
            'class' : 'RC-AD-BOX-BOTTOM-600',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1390595004947-3' : {
            'sizes' : [
                [300, 250]
            ],
            'name' : '/'+AD_ID+'/RC_300_by_250_bottom',
            'class' : 'RC-AD-BOX-BOTTOM',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1390595004947-5' : {
            'sizes' : [
                [300, 250], [300, 600], [300, 1050]
            ],
            'name' : '/'+AD_ID+'/RC_300_by_250_top',
            'class' : 'RC-AD-BOX-TOP',
            'loaded' : false,
            'closeable_pages' : [],
            //'ic_override' : '//ads.investingchannel.com/adtags/realclearmarkets/economics/300x250.js',
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1390595004947-4' : {
            'sizes' : [
                [300, 250]
            ],
            'name' : '/'+AD_ID+'/RC_300_by_250_middle',
            'class' : 'RC-AD-BOX-MIDDLE',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1390595004947-2' : { // NOT IN PUBLIR 264
            'sizes' : [
                [160, 600]
            ],
            'name' : '/'+AD_ID+'/RC_160_by_600_top',
            'class' : 'RC-AD-SKY-TOP',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1390595004947-1' : { // NOT IN PUBLIR 264
            'sizes' : [
                [160, 600]
            ],
            'name' : '/'+AD_ID+'/RC_160_by_600_bottom',
            'class' : 'RC-AD-SKY-BOTTOM',
            'loaded' : false,
            'closeable_pages' : [],
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1416850836025-5' : { // NOT IN PUBLIR 264
            'sizes' : [
                [300, 250]
            ],
            'name' : '/'+AD_ID+'/RC_300_by_250_widget',
            'class' : 'RC-AD-BOX-WIDGET',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1340813990105-0' : { // NOT IN PUBLIR 264
            'sizes' : [
                [320, 50]
            ],
            'name' : '/'+AD_ID+'/RC_mobile',
            'class' : 'RC-AD-MOBILE-BANNER',
            'loaded' : false,
            'closeable_pages' : ['home', 'article', 'polls', 'video', 'maps', 'elections'],
            'styles' : {'background': '#fff'}, //needs to be an object
            'slot_definition' : null,
            'refresh_time': 20000, //refresh this ad every 30 seconds
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-welcome' : { // NOT IN PUBLIR 264, 369
            'sizes' : [
                [1, 1]
            ],
            'name' : '/'+AD_ID+'/RC_1_by_1_welcome',
            'class' : 'RC-AD-WELCOME',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1416850836025-7' : { // NOT IN PUBLIR 264, 369
            'sizes' : [
                [250,180]
            ],
            'name' : '/'+AD_ID+'/RC_Lc',
            'class' : 'RC-AD-LC',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            'refresh_time': 600000, //refresh this ad every 10 minutes
            'no_refresh': true, // don't refresh this ad
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1601314966506-0' : { // NOT IN PUBLIR 264, 369
            'sizes' : [
                [216, 40] /*, [250,250], [250,360], */
            ],
            'name' : '/'+AD_ID+'/RC_Lc_2',
            'class' : 'RC-AD-LC-2',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            'refresh_time': 600000, //refresh this ad every 10 minutes
            'no_refresh': true, // don't refresh this ad
        },
        'div-gpt-ad-1448303538392-0' : { // NOT IN PUBLIR 264, 369
            'sizes' : [
                [970,90],[970,250]
            ],
            'name' : '/'+AD_ID+'/RC_970_by_90',
            'class' : 'RC-AD-TOP-BANNER-BIG',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1390595004947-8' : { // NOT IN PUBLIR 264, 369
            'sizes' : [
                [300, 250]
            ],
            'name' : '/'+AD_ID+'/RC_300_by_250_carousel',
            'class' : 'RC-AD-BOX-MOBILE_1',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1390595004947-9' : { // NOT IN PUBLIR 264, 369
            'sizes' : [
                [300, 250]
            ],
            'name' : '/'+AD_ID+'/RC_300_by_250_house',
            'class' : 'RC-AD-BOX-MOBILE_2',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
        'div-gpt-ad-1496845181660-0' : { // NOT IN PUBLIR 264, 369
            'sizes' : [
                [1, 1]
            ],
            'name' : '/'+AD_ID+'/RC_1_by_1_tynt',
            'class' : 'RC-AD-TYNT',
            'loaded' : false,
            'closeable_pages' : [],
            'slot_definition' : null,
            // 'dont_refresh' : false,
        },
    };
}

function getAdsConfig(){

    return {
        AD_ID: getAdsId(),
        ads_info: getAdsInfo(),
        HAS_INIT_ADS: HAS_INIT_ADS,
        LAZY_ADS_ENABLED: LAZY_ADS_ENABLED,
        PREBIDDING_ENABLED: PREBIDDING_ENABLED,
    };
}

function setGlobalAdsConfigs(){
    console.log("ADS setGlobalAdsConfigs");

    let configs = getAdsConfig();

    for (const key in configs) {
        window[key] = configs[key];
    }
}

function addMoatTag() {

    return new Promise((resolve, reject) => {

        if( ['politics'].indexOf(SITE_INFO['name']) > -1 ) {
            
            var el = document.createElement("script");
            el.src = "https://z.moatads.com/realclearmediaheader300485513262/moatheader.js";
            el.async = true;
            el.onload = resolve;
            el.onerror = resolve;
            
            document.querySelector('head').appendChild(el);
        } else {
            resolve();
        }
    });
}

function addGPTTag() {

    // if (gptWasAdded) return;

    return new Promise((resolve, reject) => {

        console.log("ADS addGPTTag");

        var el = document.createElement("script");
        el.src = "https://www.googletagservices.com/tag/js/gpt.js";
        el.async = true;

        if( !PREBIDDING_ENABLED ){
            el.onreadystatechange = resolve;
            el.onload = resolve;
            el.onerror = resolve;
        }

        document.querySelector('head').appendChild(el);

        if (PREBIDDING_ENABLED) {
            var prebid_el = document.createElement("script");
            prebid_el.src = SITE_INFO['prebid_src'];
            prebid_el.id = 'headerbidder';
            prebid_el.async = true;

            // if prebid call gpt loaded here
            prebid_el.onreadystatechange = resolve;
            prebid_el.onload = resolve;
            prebid_el.onerror = resolve;

            document.querySelector('head').appendChild(prebid_el);
        }

        // gptWasAdded = true;
    });
}

export {
    getAdsId,
    getAdsInfo,
    getAdsConfig,
    setGlobalAdsConfigs,
    addGPTTag,
    addMoatTag,
};